<crm-single-select
  [options]="options"
  [(selectedItem)]="type"
  (selectedItemChange)="typeChange.emit($event)"
  [class]="class"
  [styleClass]="styleClass"
  optionValue="name"
  [appendTo]="appendTo"
  [filter]="false"
  [isTemplateCombined]="true">
  <ng-template
    #itemTemplate
    let-type="item">
    {{ type.value | bankStatementRuleJointTypeName }}
  </ng-template>
</crm-single-select>
